<div class="loading-screen d-flex justify-content-center align-items-center">
    <mat-spinner mode="indeterminate" color="primary"></mat-spinner>
</div>